// CenterSelection.jsx

import React from "react";
import CenterSelector from "../CenterSelector/CenterSelector";

function CenterSelection(props) {
  const {
    centers,
    currentCenterId,
    centerSelectionURL,
    csrfToken,
  } = props;

  return (
    <div>
      <h4 className="text-center mb-3">Seleziona il centro</h4>

      <p className="text-center mb-4">Scegli il centro in cui vuoi operare.</p>

      <CenterSelector
        centers={centers}
        currentCenterId={currentCenterId}
        centerSelectionURL={centerSelectionURL}
        csrfToken={csrfToken}
      />
    </div>
  );
}

export default CenterSelection;